import { createSlice } from "@reduxjs/toolkit";

const LS_KEY = "activeProject";

const loadPersistedProject = () => {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const persisted = loadPersistedProject();

const projectSlice = createSlice({
  name: "project",
  initialState: {
    activeProjectId: persisted?.activeProjectId ?? null,
    activeProjectName: persisted?.activeProjectName ?? null,
    activeProjectCity: persisted?.activeProjectCity ?? null,
    isDirty: false, // tracks whether any form has unsaved changes
  },
  reducers: {
    setActiveProject(state, { payload }) {
      state.activeProjectId = payload.id;
      state.activeProjectName = payload.name;
      state.activeProjectCity = payload.city ?? null;
      state.isDirty = false;
      localStorage.setItem(
        LS_KEY,
        JSON.stringify({
          activeProjectId: payload.id,
          activeProjectName: payload.name,
          activeProjectCity: payload.city ?? null,
        }),
      );
    },
    clearActiveProject(state) {
      state.activeProjectId = null;
      state.activeProjectName = null;
      state.activeProjectCity = null;
      state.isDirty = false;
      localStorage.removeItem(LS_KEY);
    },
    setFormDirty(state, { payload }) {
      state.isDirty = !!payload;
    },
  },
});

export const { setActiveProject, clearActiveProject, setFormDirty } =
  projectSlice.actions;

export const selectActiveProjectId = (state) => state.project.activeProjectId;
export const selectActiveProjectName = (state) => state.project.activeProjectName;
export const selectActiveProjectCity = (state) => state.project.activeProjectCity;
export const selectIsFormDirty = (state) => state.project.isDirty;

export default projectSlice.reducer;
